import React from 'react';
import LibraryConfirmationDialog from './LibraryConfirmationDialog';

function LibraryDeleteFileDialog({ isOpen, onCancel, onConfirm, fileName, t }) {
  return (
    <LibraryConfirmationDialog
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={onConfirm}
      title={t('library-confirm-delete-title')}
      description={t('library-confirm-delete-body', { fileName })}
      cancelLabel={t('common-cancel')}
      confirmLabel={t('library-action-delete-file')}
    />
  );
}

export default LibraryDeleteFileDialog;
